module.exports = __webpack_public_path__ + "img/image 1130@2x.0898d7a4.png";